"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeButtonStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeButtonStyles = function makeButtonStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;

  var getButtonStyles = function getButtonStyles(_ref2) {
    var size = _ref2.size,
        variant = _ref2.variant;
    var button = tokens.button; // Rewrite font size value to incorporate root font size factor

    var fontSize = size === "dense" ? primitives.fontSizes[2] : primitives.fontSizes[3];
    return _objectSpread(_objectSpread({}, button[variant][size].default), {}, {
      fontSize: fontSize,
      "&:hover": _objectSpread(_objectSpread({}, button[variant][size].hover), {}, {
        fontSize: fontSize
      }),
      "&.Mui-disabled": _objectSpread(_objectSpread({}, button[variant][size].disabled), {}, {
        fontSize: fontSize
      }),
      "&:focus": _objectSpread(_objectSpread({}, button[variant][size].focus), {}, {
        fontSize: fontSize
      }),
      "&:focus:active": _objectSpread(_objectSpread({}, button[variant][size].pressed), {}, {
        fontSize: fontSize
      }),
      "&:active": _objectSpread(_objectSpread({}, button[variant][size].pressed), {}, {
        fontSize: fontSize
      })
    });
  };

  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiButton: {
      defaultProps: {
        variant: "contained"
      },
      styleOverrides: {
        outlined: getButtonStyles({
          size: "defaultSize",
          variant: "outlined"
        }),
        outlinedSizeSmall: getButtonStyles({
          size: "dense",
          variant: "outlined"
        }),
        contained: getButtonStyles({
          size: "defaultSize",
          variant: "contained"
        }),
        containedSizeSmall: getButtonStyles({
          size: "dense",
          variant: "contained"
        }),
        text: getButtonStyles({
          size: "defaultSize",
          variant: "text"
        }),
        textSizeSmall: getButtonStyles({
          size: "dense",
          variant: "text"
        }),
        startIcon: {
          "& svg": {
            color: "inherit"
          },
          "& .DhigProgress--foreground": {
            color: "inherit !important"
          }
        },
        endIcon: {
          "& svg": {
            color: "inherit"
          }
        },
        iconSizeMedium: {
          "& > *:first-of-type": {
            fontSize: "inherit"
          }
        },
        root: {
          '& [class*="MuiTouchRipple-root"]': {
            display: "none"
          }
        }
      }
    }
  };
};

exports.makeButtonStyles = makeButtonStyles;